import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import * as Helper from '@/helpers'

@Component
export class MixinRouteMatch extends Vue {
  updateRouteFromObject(value: any, queriesToHide: string[] = []) {
    const query: any = { ...this.$route.query, ...Helper.classToPlain(value) }

    for (const key of queriesToHide) {
      delete query[key]
    }

    this.prepareToSerialize(query)
    this.$router.replace({ query })
  }

  updateObjectFromRoute(value: any) {
    const query = { ...Helper.classToPlain(value), ...this.$route.query }
    this.prepareToUnserialize(query)
    Helper.plainToClassFromExist(value, query)
  }

  private prepareToSerialize(obj: any) {
    Object.keys(obj).forEach((key) => {
      if (obj[key] == null || obj[key] === '') {
        delete obj[key]
      }
    })
  }

  private prepareToUnserialize(obj: any) {
    Object.keys(obj).forEach((key) => {
      if (typeof obj[key] === 'string') {
        const match = /^['"](.+)['"]$/.exec(obj[key])

        if (!obj[key].length) {
          obj[key] = null
        } else if (!isNaN(obj[key]) && !obj[key].startsWith('0')) {
          obj[key] = Number(obj[key])
        } else if (match && match[1]) {
          obj[key] = match[1]
        }
      } else if (obj[key] === 'true') {
        obj[key] = true
      } else if (obj[key] === 'false') {
        obj[key] = false
      }
    })
  }
}
